import * as React from "react";
const SvgPeopleFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M7 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8m10 0a4 4 0 1 1 0 8 4 4 0 0 1 0-8M7 12a4 4 0 0 1 4 4v5a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-5a4 4 0 0 1 4-4m10 0a4 4 0 0 1 4 4v5a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-5a4 4 0 0 1 4-4", clipRule: "evenodd" }));
export default SvgPeopleFill;
